/**
 * List Buttons Component
 * Itemize and Enumerate buttons for LaTeX toolbar
 */

import React from 'react'
import { EditorView } from '@codemirror/view'
import {
  ListBulletIcon,
} from '@heroicons/react/24/outline'
import clsx from 'clsx'
import { insertItemize, insertEnumerate } from '@/utils/latex/insertionHelpers'

// Custom numbered list icon (not available in Heroicons)
const ListNumbersIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg className={className} fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
    <path strokeLinecap="round" strokeLinejoin="round" d="M7 20l4-16m2 16l4-16M6 9h14M4 15h14" />
  </svg>
)

interface ListButtonsProps {
  view: EditorView | null
  theme?: 'light' | 'dark'
}

const ListButtons: React.FC<ListButtonsProps> = ({ view, theme = 'light' }) => {
  const handleItemize = () => {
    if (!view) return
    insertItemize(view, 1)
    view.focus()
  }

  const handleEnumerate = () => {
    if (!view) return
    insertEnumerate(view, 1)
    view.focus()
  }

  const buttonClass = clsx(
    'p-1.5 rounded transition-colors',
    theme === 'dark'
      ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
      : 'text-gray-800 hover:bg-gray-100 hover:text-gray-900',
    'disabled:opacity-50 disabled:cursor-not-allowed'
  )

  return (
    <div className="flex items-center gap-1">
      <button
        type="button"
        onClick={handleItemize}
        disabled={!view}
        className={buttonClass}
        title="Bullet list (Itemize) - Inserts \\begin{itemize}...\\end{itemize}"
        aria-label="Bullet list"
      >
        <ListBulletIcon className="w-4 h-4" />
      </button>
      <button
        type="button"
        onClick={handleEnumerate}
        disabled={!view}
        className={buttonClass}
        title="Numbered list (Enumerate) - Inserts \\begin{enumerate}...\\end{enumerate}"
        aria-label="Numbered list"
      >
        <ListNumbersIcon className="w-4 h-4" />
      </button>
    </div>
  )
}

export default ListButtons

